import WavyLoader from "components/v2/WavyLoader";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";

const LoadingCart = () => {
	return (
		<Container>
			<PaddingX>
				<div className="max-w-7xl mx-auto pt-8 space-y-6">
					<div className="flex justify-between items-start gap-4">
						<div className="space-y-2">
							<WavyLoader height={24} width={220} />
							<WavyLoader height={14} width={180} />
						</div>
						<WavyLoader height={24} width={80} />
					</div>

					<div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
						<div className="col-span-12 lg:col-span-8 space-y-3">
							<WavyLoader height={140} width="100%" className="rounded-xl" />
							<WavyLoader height={140} width="100%" className="rounded-xl" />
						</div>
						<div className="col-span-12 lg:col-span-4">
							<WavyLoader height={360} width="100%" className="rounded-2xl" />
						</div>
					</div>
				</div>
			</PaddingX>
		</Container>
	);
};

export default LoadingCart;
